import React from "react";
import {BETREIBER, FACHADMIN, SYSTEMADMIN, ZUST_SBD} from "../../../consts/funktionaleRollen";
import {userHasAnyRole} from "../../../utils/SecurityUtils";
import EATextField from "../../EATextField";

export function AnlagenHeader(props) {
    const mainDivClassName = props.biggerBezeichnung ? "gridl gridForAnlagenHeaderWithBiggerBezeichnung" : "gridl gridForAnlagenHeader";

    return (
        <div className={mainDivClassName}>
            {props.formFactory.renderInput("anlagenId", "anlagenId", "Anlage-Nr.", "text", true)}
            {props.formFactory.renderInput(
                "bezeichnung",
                "bezeichnung",
                "Bezeichnung",
                "text",
                props.disabled ||
                (!props.isEntlastung && !userHasAnyRole([ZUST_SBD, FACHADMIN, SYSTEMADMIN])) ||
                (props.isEntlastung && !userHasAnyRole([ZUST_SBD, FACHADMIN, SYSTEMADMIN, BETREIBER])),
            )}
            {props.formFactory.renderInput("anlagentyp.value", "anlagentyp.value", "Anlagentyp", "text", true)}
            {props.formFactory.renderSelect("anlagenstatus", "anlagenstatus", "Status", props.anlagenstatusOptionen, props.statusDisabled, {
                optionTitle: "value",
                optionKey: "id",
            })}
            {props.angeschlosseneAnlage &&
            <div>
                {props.formFactory.renderInput("angeschlosseneAnlage.value", "angeschlosseneAnlage.value", "Anlage", "text", true)}
            </div>}
            {!props.angeschlosseneAnlage && props.anlagenstatus?.id === "ANGESCHLOSSEN_AN" &&
                <EATextField id={"keineAngeschlosseneAnlageInfo"} value={"(keine)"} disabled/>
            }
            <div style={{maxWidth: "8em"}}>
                {props.formFactory.renderDatePicker("statuswechsel",
                    "statuswechsel",
                    "Seit",
                    props.statusDisabled,
                )}
            </div>
        </div>
    );
}
